import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContainerForm } from '@/components';
import { CreateElement, VNode } from 'vue';
import { IRecoveryPassInfo, IRecoveryPassInfoComponent, IRegistrationTranslation } from '@/types';
import { mapGetters } from 'vuex';
import './styles.styl';

@Component({
  name: 'RecoveryPassInfo',
  computed: {
    ...mapGetters('accounts', ['translations']),
    t(): IRecoveryPassInfo { return (this.translations as IRegistrationTranslation).messageSendMail; },
  },
})
export default class RecoveryPassInfo extends Vue implements IRecoveryPassInfoComponent {
  @Prop({type: String, default: ''}) public readonly email!: string;

  public t!: IRecoveryPassInfo;

  private created() {
    if (!this.email) {
      this.$router.push({name: 'pageNotFound'});
    }
  }

  private render(createElement: CreateElement): VNode {

    const address = this.email || this.t.phrase;

    const text: VNode = createElement('p', {
      class: [
        { 'recovery-pass__paragraph': true },
        this.$vuetify.breakpoint.xsOnly
          ? 'paragraph__mobile'
          : 'paragraph__desktop',
      ],
    }, `${this.t.message} ${address}`);

    return createElement(ContainerForm, [
      this.$slots.title,
      text,
    ]);
  }
}
